/**
 * Use this instead of MUI chip.
 */

import {
  TEAL_300,
  TEAL_600,
  THEME,
} from '@wandb/weave/common/css/globals.styles';
import {type IconName} from '@wandb/weave/components/Icon';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import * as S from './Chip.styles';

type ChipProps = {
  icon?: string | React.ReactNode;
  label: React.ReactNode;
  tooltip?: string;
  color?: string;
  backgroundColor?: string;
  dataTest?: string;
};

const DEFAULT_BACKGROUND_COLOR = `light-dark(color-mix(in srgb, ${TEAL_300} 48%, transparent), color-mix(in srgb, var(--teal-800) 48%, transparent))`;
const DEFAULT_COLOR = `light-dark(${TEAL_600}, ${THEME.textLink})`;

export const Chip = ({
  icon,
  label,
  tooltip,
  color,
  backgroundColor,
  dataTest,
}: ChipProps) => {
  if (typeof icon === 'string') {
    icon = <S.Icon name={icon as IconName} />;
  }
  const style = {
    backgroundColor: backgroundColor ?? DEFAULT_BACKGROUND_COLOR,
    color: color ?? DEFAULT_COLOR,
  };

  const chip = (
    <S.Chip style={style} data-test={dataTest}>
      {icon}
      {label}
    </S.Chip>
  );

  if (tooltip) {
    return <Tooltip content={tooltip} trigger={chip} />;
  }
  return chip;
};
